/**
 * This is a list of the image resources in the @mcleod/images package that can
 * be used to help with code completion and some compile time checking of constants.
*/

/*
Here is a groovy script that can generate the contents of this enum:

import java.io.*;

File dir = new File(System.getProperty("user.home") + "/git/loadmaster/mcleod-ui/images/src/images");
addDirectory(dir, "");

private void addDirectory(File dir, String prefix) {
    for (File f : dir.listFiles())
        if (!f.isDirectory()) {
            String n = f.getName().replace(".ts", "");
            System.out.println("\t\"" + prefix + n + "\" : \"" + prefix +  n + "\",");
        }

    for (File f : dir.listFiles())
        if (f.isDirectory())
            addDirectory(f, f.getName() + "/");
}

*/

export type ImageName = keyof typeof ImageNames | string;

export const ImageNames = {
    "acceptTender": "acceptTender",
    "activateSlideout": "activateSlideout",
    "activeCircle" : "activeCircle",
    "add": "add",
    "addGhost": "addGhost",
    "addInBox": "addInBox",
    "addRecovery": "addRecovery",
    "activeMonitorUpdate":"activeMonitorUpdate",
    "defaultMonitorUpdate":"defaultMonitorUpdate",
    "arrow": "arrow",
    "arrowDown": "arrowDown",
    "arrowSplit": "arrowSplit",
    "arrowUp": "arrowUp",
    "ascending": "ascending",
    "autoMatch": "autoMatch",
    "balanceDue": "balanceDue",
    "bridgeCustomer": "bridgeCustomer",
    "bridgeCustomerTurned": "bridgeCustomerTurned",
    "brokenPallet": "brokenPallet",
    "brokerageBadge": "brokerageBadge",
    "bypassBatch": "bypassBatch",
    "calendar": "calendar",
    "cancel": "cancel",
    "carrierRemove": "carrierRemove",
    "chartLine": "chartLine",
    "chatEmpty": "chatEmpty",
    "chatImportant": "chatImportant",
    "chatLines": "chatLines",
    "chatPerson": "chatPerson",
    "driverMsgNormal": "driverMsgNormal",
    "check": "check",
    "checkboxChecked": "checkboxChecked",
    "checkboxIndeterminate": "checkboxIndeterminate",
    "checkboxUnchecked": "checkboxUnchecked",
    "chevron": "chevron",
    "circleCheck": "circleCheck",
    "circleCheckEmpty": "circleCheckEmpty",
    "circleEmpty": "circleEmpty",
    "circleFilled": "circleFilled",
    "circlePlusFilled": "circlePlusFilled",
    "circleQuestion": "circleQuestion",
    "circleError": "circleError",
    "circleErrorSolid": "circleErrorSolid",
    "circleX": "circleX",
    "classicModel": "classicMode",
    "clipboard": "clipboard",
    "clock": "clock",
    "codeTags": "codeTags",
    "copy": "copy",
    "curlyBrackets": "curlyBrackets",
    "dash": "dash",
    "dataFusionCustomer": "dataFusionCustomer",
    "declineTender": "declineTender",
    "delete": "delete",
    "delivery": "delivery",
    "descending": "descending",
    "detail": "detail",
    "disk": "disk",
    "diskX": "diskX",
    "document": "document",
    "doubleChevron": "doubleChevron",
    "download": "download",
    "drivers": "drivers",
    "duplicateDisk": "duplicateDisk",
    "ellipsis": "ellipsis",
    "excludeTender": "excludeTender",
    "emailVerified": "emailVerified",
    "emailStatusUnknown": "emailStatusUnknown",
    "emailUnVerified":"emailUnverified",
    "expand": "expand",
    "exit": "exit",
    "fan": "fan",
    "folder": "folder",
    "form": "form",
    "formPencil": "formPencil",
    "formPencilHigh": "formPencilHigh",
    "fuelPrice": "fuelPrice",
    "funnel": "funnel",
    "hamburger": "hamburger",
    "heart": "heart",
    "hierarchy": "hierarchy",
    "highway_icon":"highway_icon",
    "highwayError":"highwayError",
    "highwayEmailVerificationLogo":"highwayEmailVerificationLogo",
    "hmmm": "hmmm",
    "home": "home",
    "import": "import",
    "inboundTender": "inboundTender",
    "inboundTenderWarning": "inboundTenderWarning",
    "inboundShipmentStatusError": "inboundShipmentStatusError",
    "intercompany": "intercompany",
    "isoMarkPurple": "isoMarkPurple",
    "layout": "layout",
    "link": "link",
    "listSearch": "listSearch",
    "listStar": "listStar",
    "loaded":"loaded",
    "loadboardRefresh": "loadboardRefresh",
    "loadboardRatesPosted": "loadboardRatesPosted",
    "ltlPalletQuote": "ltlPalletQuote",
    "magnifyingGlass": "magnifyingGlass",
    "magnifyingGlassPage": "magnifyingGlassPage",
    "envelopeRead": "envelopeRead",
    "mapPinPerson": "mapPinPerson",
    "messagesConfirm": "messagesConfirm",
    "messagesIncomingFilled": "messagesIncomingFilled",
    "messagesIncomingOutlined": "messagesIncomingOutlined",
    "messagesOutgoingFilled": "messagesOutgoingFilled",
    "messagesOutgoingOutlined": "messagesOutgoingOutlined",
    "messagesReply": "messagesReply",
    "messagesFleet": "messagesFleet",
    "messagesConversation": "messagesConversation",
    "mobileCommChats": "mobileCommChats",
    "money": "money",
    "moneyInHand": "moneyInHand",
    "multipleSelected": "multipleSelected",
    "selectAll": "selectAll",
    "searchOrders": "searchOrders",
    "noPencil": "noPencil",
    "notLoaded":"notLoaded",
    "number": "number",
    "offered": "offered",
    "oneToMany": "oneToMany",
    "oneToOne": "oneToOne",
    "orderHistoryWithAlerts": "orderHistoryWithAlerts",
    "outboundDFInvoiceError": "outboundDFInvoiceError",
    "outboundInvoiceStatus": "outboundInvoiceStatus",
    "outboundShipmentStatusError": "outboundShipmentStatusError",
    "outboundTender": "outboundTender",
    "overlappingWindows": "overlappingWindows",
    "package": "package",
    "packageError": "packageError",
    "lock": "lock",
    "pencil": "pencil",
    "shipmentLocation": "shipmentLocation",
    "loadBoardPostingError": "loadBoardPostingError",
    "rebill": "rebill",
    "report": "report",
    "reprintFreightBill": "reprintFreightBill",
    "summaryInvoice": "summaryInvoice",
    "people": "people",
    "person": "person",
    "pickup": "pickup",
    "pictureOutlined": "pictureOutlined",
    "mPact": "mPact",
    "topMatch": "topMatch",
    "triangleWarning": "triangleWarning",
    "pinOutlined": "pinOutlined",
    "pointer": "pointer",
    "pop": "pop",
    "printed": "printed",
    "pushPin": "pushPin",
    "quickPay": "quickPay",
    "rateThisOrder": "rateThisOrder",
    "rawData": "rawData",
    "rocketShip": "rocketShip",
    "readyToPrint": "readyToPrint",
    "readyToSubmit": "readyToSubmit",
    "redo": "redo",
    "refresh": "refresh",
    "resubmit": "resubmit",
    "run": "run",
    "seated": "seated",
    "settings": "settings",
    "settlements": "settlements",
    "share": "share",
    "showTransmissionLog": "showTransmissionLog",
    "shrink": "shrink",
    "sortingOff": "sortingOff",
    "spinner": "spinner",
    "splitBill": "splitBill",
    "splitViewHorizontal": "splitViewHorizontal",
    "splitViewTimeline": "splitViewTimeline",
    "splitViewVertical": "splitViewVertical",
    "star": "star",
    "steeringWheel": "steeringWheel",
    "suggestedPricing": "suggestedPricing",
    "tab": "tab",
    "trailer": "trailer",
    "tenders": "tenders",
    "textSearch": "textSearch",
    "timeExpired": "timeExpired",
    "timeWarning15": "timeWarning15",
    "timeWarning30": "timeWarning30",
    "timeWarning60": "timeWarning60",
    "transferredToSettlements": "transferredToSettlements",
    "truck": "truck",
    "unavailable": "unavailable",
    "unbilled": "unbilled",
    "undo": "undo",
    "unseated": "unseated",
    "viaPoint": "viaPoint",
    "viewRecovery": "viewRecovery",
    "visibilityOff": "visibilityOff",
    "visibilityOn": "visibilityOn",
    "x": "x",
    "zMit": "zMit",
    "zMitNotTransmitted": "zMitNotTransmitted",
    "zMitTransmitted": "zMitTransmitted",
    "zMitTransmittedAccepted": "zMitTransmittedAccepted",
    "zMitTransmittedRejected": "zMitTransmittedRejected",
    "designer/attachment": "designer/attachment",
    "designer/button": "designer/button",
    "designer/checkbox": "designer/checkbox",
    "designer/citystate": "designer/citystate",
    "designer/dataheader": "designer/dataheader",
    "designer/datasource": "designer/datasource",
    "designer/function": "designer/function",
    "designer/horizontalspacer": "designer/horizontalspacer",
    "designer/image": "designer/image",
    "designer/innerJoin": "designer/innerJoin",
    "designer/input": "designer/input",
    "designer/label": "designer/label",
    "designer/layout": "designer/layout",
    "list": "list",
    "designer/map": "designer/map",
    "designer/numbereditor": "designer/numbereditor",
    "designer/outerJoin": "designer/outerJoin",
    "designer/panel": "designer/panel",
    "designer/savebutton": "designer/savebutton",
    "designer/searchbutton": "designer/searchbutton",
    "designer/splitter": "designer/splitter",
    "designer/starrating": "designer/starrating",
    "designer/stepper": "designer/stepper",
    "designer/switch": "designer/switch",
    "designer/tab": "designer/tab",
    "designer/table": "designer/table",
    "designer/tabset": "designer/tabset",
    "designer/textbox": "designer/textbox",
    "designer/tree": "designer/tree",
    "designer/widget": "designer/widget",
    "datLogo": "datLogo",
};
